"use client";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { solution as data } from "@/lib/data/platform-pricing";

export function Solution() {
  return (
    <Section id="solution" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-crimson)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid lg:grid-cols-3 gap-5">
          {data.pillars.map((p, i) => (
            <Reveal key={p.title} delay={i * 80}>
              <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, var(--color-crimson) 14%, transparent)` }}>
                <div className="text-[10px] font-bold tracking-widest text-[var(--color-crimson)] uppercase">Pillar {String(i + 1).padStart(2, "0")}</div>
                <h3 className="mt-3 text-lg">{p.title}</h3>
                <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={300}>
          <div className="mt-10">
            <Link href={data.cta.href} className="btn-primary-gradient h-12 px-7 inline-flex items-center gap-2 rounded-full font-semibold text-base">
              {data.cta.label} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
